import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthorizationService } from '../services/authorization.service';
import type { AuthorizationOptions } from '../types';

export const authorizationGuard: (options: AuthorizationOptions) => CanActivateFn = (options) => (route) => {
  const router = inject(Router);
  const authorizationService = inject(AuthorizationService);

  return authorizationService
    .checkIsAuthorized(options)
    .then((isAuthorized) => {
      if (!isAuthorized) {
        router.navigate(['forbidden']);
        return false;
      }

      return true;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('🚀 ~ authorizationGuard::error:', error);

      return false;
    });
};
